import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e44d34a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "panel-attribute" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "header-buttons" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-expand" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "content"
}
const _hoisted_8 = { class: "teleported-wrapper" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "teleported-mask" }, null, -1))
const _hoisted_10 = { class: "teleported-content" }
const _hoisted_11 = { class: "header" }
const _hoisted_12 = { class: "title" }
const _hoisted_13 = { class: "header-buttons" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-compress" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.expandable)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "header-button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.expanded = true))
            }, _hoisted_6))
          : _createCommentVNode("", true)
      ])
    ]),
    (!_ctx.expanded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.expanded && _ctx.expandable)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 1,
          to: "body"
        }, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.title), 1),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("button", {
                    class: "header-button",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.expanded = false))
                  }, _hoisted_15)
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _renderSlot(_ctx.$slots, "default", {}, undefined, true)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}